//Permanent
const brand = "El Comercio";
const twitterAccount = "elcomercio_peru";    
const urlBrand = "https://elcomercio.pe/";
const urlPortadaEspeciales = "https://especiales.elcomercio.pe/?q=especiales/especiales-el-comercio/index.html";
const domainMarca = "https://especiales.elcomercio.pe/?q=especiales/";
const domainAssets = 'https://d1ts5g4ys243sh.cloudfront.net/proyectos_especiales_prod/especiales/';
const urlCommonAssets = `${domainAssets}elementos-comunes-2`;

//Variable
const socialShareText = `Terremoto de 1970: se cumplen 52 años del sismo de 7.9 que sepultó Yungay | ${brand}`;
const title = "TERREMOTO DE 1970:";
const subtitle = "EL SISMO DE 7.9 QUE SEPULTÓ YUNGAY";
const slugEspecial = "terremoto-1970-52-anos-sismo-sepulto-yungay-ancash-multimedia-nndd";
const urlEspecial = `${domainMarca}${slugEspecial}/index.html`;
const urlAssets = `${domainAssets}${slugEspecial}`;
const urlVideo = `${domainMarca}${slugEspecial}/video/video.html`;
const epigraph1 = "Este 31 de mayo se conmemoran 52 años de uno de los terremotos\nmás fuertes que azotó nuestro país.";
const epigraph2 = "Este 31 de mayo se conmemoran 52 años de uno de los terremotos\nmás fuertes que azotó nuestro país. El terremoto de Áncash de 1970,\nconocido localmente como el terremoto del 70, fue un sismo de\nmagnitud 7.9 que causó entre otras cosas, la sepultura de la ciudad de\nSanto Domingo y Yungay con sus 20.000 habitantes. En este video\nrecordaremos como se vivió ese terrible suceso.";

export { 
    brand,
    epigraph1,
    epigraph2,
    title,
    twitterAccount, 
    urlBrand, 
    urlPortadaEspeciales, 
    domainMarca, 
    domainAssets, 
    urlCommonAssets, 
    socialShareText, 
    slugEspecial, 
    subtitle,
    urlAssets, 
    urlEspecial,     
    urlVideo
}